<template>
    <div class="h-11 flex items-center justify-center rounded-lg bg-primary w-fit">
        <button
            class="quantity h-full w-10 flex justify-center items-center cursor-pointer"
            type="button"
            aria-label="Produkt Anzahl verringern"
            @click="decrement"
        >
            <MiscIcon
                name="minus"
                size="sm"
            />
        </button>
        <label :for="'quantityInput' + id" class="sr-only">{{ t('product.qty.selectorLabel') }}</label>
        <input
            :id="'quantityInput' + id"
            v-model="qty"
            type="number"
            :min="min"
            :max="max"
            :disabled="inputDisabled"
            class="w-[48px] flex justify-center font-semibold text-lg bg-transparent text-center"
        >
        <button
            class="quantity h-full w-10 flex justify-center items-center cursor-pointer"
            type="button"
            aria-label="Produkt Anzahl erhöhen"
            @click="increment"
        >
            <MiscIcon
                name="plus"
                size="sm"
            />
        </button>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const qty = defineModel<number>('qty', { required: true })
const props = withDefaults(defineProps<{
    min?: number,
    max: number,
    id: any,
    inputDisabled?: boolean
}>(), {min: 1})

function decrement () {
    if (qty.value > props.min) {
        qty.value--
    }
}

function increment () {
    if (qty.value < props.max) {
        qty.value++
    }
}
</script>

<style scoped lang="postcss">
input[type='number'] {
    -moz-appearance:textfield;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
</style>
